<div id="company-atributos-tab" class="company-atributos-tab">
    <div class="wrapper-view">
        <div class="form-wrap checkbox-view checkbox-view-top half-field">
            <mat-checkbox class="checked60"  [(ngModel)]="headerAttributosChecked" [disabled]="!editPremit" (disabledChange)="editPremit = $event" ><strong>Heredar atributos</strong></mat-checkbox>
        </div>
    </div>
    
    <div class="wrapper-view">
        
        <div class="wrapper-looper looper-left">
            <h2>Atributos</h2>
            <div *ngIf="isLoading" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
            <div class="attribute-list">
                <mat-radio-group  *ngIf="!isLoading" aria-label="Select an option">
                    <mat-radio-button (change)="loadValoresActuales(atributos.attributoValue,atributos.attributoName,atributos.define)" 
                    *ngFor="let atributos of dataSourceHeaderAtributos" 
                    value="{{atributos.attributoValue}}" 
                    [checked]="atributos.isChecked"
                    id="atr_{{atributos.attributoValue}}">
                    {{atributos.attributoName}}
                </mat-radio-button>
                    
                </mat-radio-group>
            </div>
        </div>
        <div class="wrapper-looper looper-middle">
            <div class="form-wrap">
                <mat-label class="label">Nombre del atributo</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input  (focus)="onFocusEvent($event)"  onKeyPress="if(this.value.length==20) return false;"  type="text" (blur)="onBlurNombre($event.target.value)" [disabled]="!editPremit || headerAttributosChecked" (disabledChange)="!editPremit || (headerAttributosChecked = $event)" matInput placeholder="" value="{{selecttedAtributo}}">
                </mat-form-field>
            </div>
            <div class="datalist">
                <h2>Valores actuales <button  *ngIf="valoresActualesPermit" (click)="createvaloresactuales()"><mat-icon>add</mat-icon></button></h2>
                <div *ngIf="isLoadingVal" class="m-auto">
                    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </div>
                <div *ngIf="!isLoadingVal" class="data-table">
                    <table aria-describedby="" mat-table [dataSource]="dataSourceValoresActuales" class="mat-elevation-z8">
                        <ng-container matColumnDef="position">
                            <th id="" mat-header-cell *matHeaderCellDef> Texto </th>
                            <td mat-cell *matCellDef="let element"> {{element.texto | uppercase }} </td>
                        </ng-container>
                        <!-- Name Column -->
                        <ng-container matColumnDef="option">
                            <th id="" mat-header-cell *matHeaderCellDef>  </th>
                            <td mat-cell *matCellDef="let element">
                                <button *ngIf="valoresActualesPermit" mat-icon-button (click)="deletevaloresactuales(element)">
                                    <mat-icon>delete_forever</mat-icon>
                                </button>
                                <button *ngIf="valoresActualesPermit" mat-icon-button (click)="editvaloresactuales(element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
            <div class="form-wrap">
                <mat-label class="label">Atributo de localización</mat-label>
                <mat-form-field appearance="fill">
                    <mat-select [disabled]="!editPremit" [(value)]="selectedDeLocaalizacion">
                        <mat-option>-</mat-option>
                        <mat-option value="1"> 1</mat-option>
                        <mat-option value="2"> 2</mat-option>
                        <mat-option value="3"> 3</mat-option>
                        <mat-option value="4"> 4</mat-option>
                        <mat-option value="5"> 5</mat-option>
                        <mat-option value="6"> 6</mat-option>
                        <mat-option value="7"> 7</mat-option>
                        <mat-option value="8"> 8</mat-option>
                        <mat-option value="9"> 9</mat-option>
                        <mat-option value="10"> 10</mat-option>
                        <mat-option value="11"> 11</mat-option>
                        <mat-option value="12"> 12</mat-option>
                      </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="wrapper-looper looper-right">
            <div class="form-wrap checkbox-view half-field">
                <mat-checkbox class="checked61" [disabled]="!editPremit || headerAttributosChecked" [(ngModel)]="CalcularAbsentismo"><strong>Calcular Absentismo</strong></mat-checkbox>
            </div>
            <div class="form-wrap checkbox-view half-field">
                <mat-checkbox class="checked62" [disabled]="!editPremit || headerAttributosChecked" [(ngModel)]="AtributoObligatorio"><strong>Atributo Obligatorio</strong></mat-checkbox>
            </div>
            <div class="form-wrap checkbox-view half-field">
                <mat-checkbox class="checked63" [disabled]="!editPremit || headerAttributosChecked" [(ngModel)]="CoincidirconLista"><strong>Coincidir Con Lista</strong></mat-checkbox>
            </div>
            <div class="form-wrap checkbox-view half-field">
                <mat-checkbox class="checked64" [disabled]="!editPremit || headerAttributosChecked" [(ngModel)]="MultipleconJornada"><strong>Múltiple (con % jornada)</strong></mat-checkbox>
            </div>
        </div>
    </div>
</div>